import http from "./httpService";
import { apiUrl } from ".././config.json";


export const getUserPublicProfile = (data) => {
    const apiEndPoint = `${apiUrl}/GetUserProfile/UserId`;
    return http.post(`${apiEndPoint}`,data);
  };

  export const updateUserPublicProfile = (data) => {
    const apiEndPoint = `${apiUrl}/UserProfile`;
    return http.post(`${apiEndPoint}`,data);
  };

  // export const updatePublicImageUpload = (data) => {
  //   const apiEndPoint = `${apiUrl}/ImageAPI`;
  //   return http.post(`${apiEndPoint}`,data);
  // };

  export const updatePublicImageUpload = async (imagelink) => {
      console.log(imagelink)
      // let data = {
      //   "QueryType": "Insert",
      //   "BoatHouseId": 72,
      //   "FormName": "EmployeeUser",
      //   "PrevImageLink": null,
      //   "ImageLink": imagelink
      // }
     let formdata = new FormData();
     formdata.append("QueryType", "Insert");
     formdata.append("BoatHouseId", 72);
     formdata.append("FormName", "EmployeeUser");
     formdata.append("PrevImageLink", null);
     formdata.append("ImageLink", imagelink);
     console.log(formdata)
     const apiEndPoint = `${apiUrl}/ImageAPI`;
     return http.post(`${apiEndPoint}`, formdata);
  };